module.exports = __webpack_public_path__ + "img/Wazdan.05036831.svg";